<script>
import Loader from '../UI/Loading/Loader.vue'
import LazyContent from '../UI/Loading/LazyContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'

export default {
  components: { LazyContent, Loader },
  mixins: [mixinComponent],
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    serviceType: {
      type: Object,
      required: true,
    },
    services: {
      type: Array,
      required: true,
    },
    taxIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
    duration: {
      type: Number,
      required: true,
    },
  },
  computed: {
    serviceButtonClasses() {
      return {
        btn: true,
        'btn-primary': this.active,
        'btn-toggle': !this.active,
        disabled: this.disabled,
      }
    },
    title() {
      const serviceLabel = this.serviceType.label ? this.serviceType.label : this.serviceType.name
      const titles = [serviceLabel]

      if (this.pack.length > 0) {
        titles.push(this.pack)
      }

      if (this.serviceType.includedToRent === true) {
        titles.push(this.$t('service.list.includeToRent'))
      }

      return titles.join(' ')
    },
    subtitle() {
      if (this.services.length === 0) {
        const serviceTypeAmount = this.taxIncluded
          ? this.serviceType.amountDurations[0].amountVat
          : this.serviceType.amountDurations[0].amount
        if (serviceTypeAmount > 0) {
          return this.$n(Number(serviceTypeAmount), 'currency')
        }
      }

      const totalAmount = this.services.reduce((total, service) => {
        const amountDurations = service.amountDurations
        const amountDuration = amountDurations.hasOwnProperty(this.duration)
          ? amountDurations[this.duration]
          : amountDurations[0]
        if (amountDuration === undefined) {
          return total
        }
        const amount = this.taxIncluded ? amountDuration.amountVat : amountDuration.amount

        return total + parseFloat(amount || '0')
      }, 0)

      if (totalAmount > 0 || this.active) {
        return this.$n(Number(totalAmount), 'currency')
      }

      return ''
    },
    pack() {
      const pack = this.services.find((service) => service.others && service.others.pack && service.others.pack.value)

      return !!pack ? pack : ''
    },
  },
}
</script>
<template>
  <div class="btn-group">
    <button
      v-if="editable && !disabled"
      type="button"
      class="btn btn-light"
      style="border-radius: 10rem 0 0 10rem !important"
      :disabled="loading"
      :title="$t('service.action.edit')"
      :e2e-button="'serviceEditButton-' + serviceType.id"
      @click="$emit('edit')"
    >
      <i v-if="!loading" class="fa fa-edit"></i>
      <Loader v-else />
    </button>
    <button
      type="button"
      :class="serviceButtonClasses"
      :style="editable ? 'border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;' : ''"
      :disabled="disabled"
      :title="$t(active ? 'service.action.disable' : 'service.action.enable')"
      :e2e-button="'serviceToggleButton-' + serviceType.id"
      :e2e-toggle="active ? 'enable' : 'disable'"
      @click="$emit('toggle')"
    >
      {{ title }}
      <LazyContent :loading="loading">
        <template v-if="subtitle">
          {{ subtitle }}
        </template>
      </LazyContent>
    </button>
  </div>
</template>
